module.exports = __webpack_public_path__ + "static/media/com-logo.a0c9c248.svg";